import { create } from 'zustand';

export interface SmsFormData {
  phoneNumber: string;
  message: string;
  isMarketingConsent: boolean;
}

interface SmsFormStore {
  formData: SmsFormData;
  actions: {
    updateField: <K extends keyof SmsFormData>(field: K, value: SmsFormData[K]) => void;
    updateFormData: (data: Partial<SmsFormData>) => void;
    clearForm: () => void;
    getFormData: () => SmsFormData;
  };
}

const defaultFormData: SmsFormData = {
  phoneNumber: '',
  message: '',
  isMarketingConsent: false,
};

export const useSmsFormStore = create<SmsFormStore>((set, get) => ({
  formData: defaultFormData,
  actions: {
    updateField: (field, value) =>
      set((state) => ({
        formData: {
          ...state.formData,
          [field]: value,
        },
      })),
    
    updateFormData: (data) =>
      set((state) => ({
        formData: {
          ...state.formData,
          ...data,
        },
      })),
    
    clearForm: () =>
      set({
        formData: defaultFormData,
      }),
    
    getFormData: () => get().formData,
  },
}));
